<template>
  <div class="pinch-effect-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>j × B = ∇p | 磁约束与等离子体平衡$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Plasma Column (Cylinder) -->
          <defs>
            <radialGradient id="plasmaGrad" cx="50%" cy="50%" r="50%">
              <stop offset="0%" style="stop-color:#fff;stop-opacity:1" />
              <stop offset="60%" style="stop-color:#00d2ff;stop-opacity:0.6" />
              <stop offset="100%" style="stop-color:#00d2ff;stop-opacity:0" />
            </radialGradient>
          </defs>

          <!-- The Column -->
          <rect :x="200 - currentRadius" y="40" :width="currentRadius*2" height="160" 
                fill="url(#plasmaGrad)" stroke="rgba(255,255,255,0.2)" :stroke-width="1" />
          
          <!-- Current direction (J) -->
          <line x1="200" y1="190" x2="200" y2="50" stroke="#ffd700" stroke-width="2" marker-end="url(#arrow)" />
          <text x="205" y="60" fill="#ffd700" font-size="10">电流 J</text>

          <!-- Magnetic Field Lines (B shown as loops) -->
          <g v-for="i in 3" :key="i">
             <ellipse :cx="200" :cy="60 + i*40" :rx="currentRadius + 15" ry="5" 
                      fill="none" stroke="#ff4757" stroke-dasharray="4,2" />
             <path :d="`M ${200 + currentRadius + 15},${60+i*40} L ${200+currentRadius+12},${60+i*40-3}`" 
                   stroke="#ff4757" />
          </g>

          <!-- Force Vectors (F) -->
          <g v-for="n in 6" :key="'f'+n">
             <line :x1="200 - currentRadius - 10" :y1="60 + n*20" :x2="200 - currentRadius" :y2="60 + n*20" 
                   stroke="#fff" stroke-width="2" marker-end="url(#arrow-f)" />
             <line :x1="200 + currentRadius + 10" :y1="60 + n*20" :x2="200 + currentRadius" :y2="60 + n*20" 
                   stroke="#fff" stroke-width="2" marker-end="url(#arrow-f)" />
          </g>

          <defs>
            <marker id="arrow" markerWidth="10" markerHeight="10" refX="5" refY="5" orient="auto">
              <path d="M0,0 L10,5 L0,10 Z" fill="#ffd700" />
            </marker>
            <marker id="arrow-f" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
              <path d="M0,0 L6,3 L0,6 Z" fill="#fff" />
            </marker>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>等离子体流量: {{ (Number(currentValue) * 1.5).toFixed(0) }} kA</label>
              <div class="value" :style="{color: Number(currentValue) > 70 ? '#ff4757' : '#00d2ff'}">强度: {{ currentValue > 70 ? '强箍缩' : '稳定柱' }}</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节放电电流</label>
             <el-slider v-model="currentValue" :min="10" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>箍缩效应（Pinch Effect）是载流流体（如等离子体或液态金属）在自身电流产生的磁场作用下，受到向内的洛伦兹力（安培力）而发生径向压缩的现象。当电流足够强时，这种磁压力可以平衡内部的热压。它是研究受控核聚变（如Z-箍缩装置）、闪电（雷电路径中的等离子体收缩）以及脉冲强磁场技术的核心概念。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PinchEffectViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      currentValue: 40
    }
  },
  computed: {
    currentRadius() {
       // Higher current = more pinch (smaller radius)
       return 50 - (Number(this.currentValue) * 0.3);
    }
  }
}
</script>

<style scoped lang="scss">
.pinch-effect-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
